// Modo demonstração da página Conversões: só em desenvolvimento e com `?demo=1`. Não chama o
// backend de conversões nem a Meta. No build de produção este caminho nunca roda.

const EVENTS = [
  { value: 'Purchase', label: 'Compra' }, { value: 'Lead', label: 'Lead' },
  { value: 'QualifiedLead', label: 'Lead qualificado' }, { value: 'Contact', label: 'Contato' },
  { value: 'Schedule', label: 'Agendamento' }, { value: 'SubmitApplication', label: 'Proposta enviada' },
  { value: 'CompleteRegistration', label: 'Cadastro completo' }, { value: 'Subscribe', label: 'Assinatura' },
]

const STAGES = [
  { id: 's1', nome: 'Novo lead', ordem: 1, is_ganho: false, is_perdido: false, pipeline_id: 'p1', pipeline_nome: 'Comercial' },
  { id: 's2', nome: 'Qualificado', ordem: 2, is_ganho: false, is_perdido: false, pipeline_id: 'p1', pipeline_nome: 'Comercial' },
  { id: 's3', nome: 'Proposta', ordem: 3, is_ganho: false, is_perdido: false, pipeline_id: 'p1', pipeline_nome: 'Comercial' },
  { id: 's4', nome: 'Ganho', ordem: 4, is_ganho: true, is_perdido: false, pipeline_id: 'p1', pipeline_nome: 'Comercial' },
  { id: 's5', nome: 'Perdido', ordem: 5, is_ganho: false, is_perdido: true, pipeline_id: 'p1', pipeline_nome: 'Comercial' },
  { id: 's6', nome: 'Contrato assinado', ordem: 1, is_ganho: true, is_perdido: false, pipeline_id: 'p2', pipeline_nome: 'Pós-venda' },
]

const ago = (minutes) => new Date(Date.now() - minutes * 60000).toISOString()

let log = [
  { id: 'l1', deal_titulo: 'Clínica Sorriso', event_name: 'Purchase', source: 'rule', status: 'sent', error: null, summary: { identifiers: ['e-mail', 'telefone'], value: 4800, currency: 'BRL' }, attempts: 1, created_at: ago(12) },
  { id: 'l2', deal_titulo: 'Padaria Central', event_name: 'QualifiedLead', source: 'automation', status: 'sent', error: null, summary: { identifiers: ['lead_id', 'telefone'], value: null }, attempts: 1, created_at: ago(95) },
  { id: 'l3', deal_titulo: 'Oficina do Zé', event_name: 'Purchase', source: 'rule', status: 'failed', error: 'A Meta recusou o evento. Dataset não encontrado.', summary: { identifiers: ['e-mail'], value: 1200, currency: 'BRL' }, attempts: 2, created_at: ago(300) },
  { id: 'l4', deal_titulo: 'Studio Pilates', event_name: 'Purchase', source: 'rule', status: 'skipped', error: 'O contato do negócio não tem e-mail, telefone nem lead de formulário para a Meta ligar ao anúncio.', summary: { identifiers: [] }, attempts: 1, created_at: ago(1500) },
]

let saved = {
  settings: { meta_account_id: 'act_1001', dataset_id: '9000001', enabled: true, enabled_at: ago(4000) },
  event_map: [{ stage_id: 's2', event_name: 'QualifiedLead' }, { stage_id: 's4', event_name: 'Purchase' }],
}

const wait = (ms = 350) => new Promise((resolve) => { setTimeout(resolve, ms) })

export async function demoLoad() {
  await wait(200)
  return {
    ...saved,
    stages: STAGES,
    accounts: [{ id: 'act_1001', name: 'Loja Exemplo — BRL', currency: 'BRL' }, { id: 'act_1002', name: 'Filial Centro', currency: 'BRL' }],
    events: EVENTS,
  }
}

export async function demoDatasets() {
  await wait(250)
  return { pixels: [{ id: '9000001', name: 'Pixel da loja' }, { id: '9000002', name: 'Dataset CRM' }], warnings: [] }
}

export async function demoSave(body) {
  await wait()
  saved = {
    settings: { meta_account_id: body.meta_account_id, dataset_id: body.dataset_id, enabled: body.enabled, enabled_at: ago(0) },
    event_map: body.event_map,
  }
  return saved
}

export async function demoTest({ code }) {
  await wait(600)
  if (code.toLowerCase().includes('erro')) throw new Error('A Meta recusou o evento. Código de teste inválido.')
  return { ok: true, events_received: 1, fbtrace_id: 'DEMO-TRACE' }
}

export async function demoLog({ result }) {
  await wait(150)
  return log.filter((row) => !result || row.status === result)
}

export async function demoRetry({ id }) {
  await wait(500)
  log = log.map((row) => (row.id === id
    ? { ...row, status: 'sent', error: null, source: 'retry', attempts: row.attempts + 1 }
    : row))
  return log.find((row) => row.id === id)
}
